import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PlayerInterface from './PlayerInterface';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { motion } from 'motion/react';
import { Gamepad2, ArrowLeft } from 'lucide-react';

const GameJoinPage: React.FC = () => {
  const { roomCode: urlRoomCode } = useParams<{roomCode: string;}>();
  const { toast } = useToast();
  const [roomCode, setRoomCode] = useState(urlRoomCode || '');
  const [showPlayerInterface, setShowPlayerInterface] = useState(false);

  useEffect(() => {
    if (urlRoomCode) {
      setRoomCode(urlRoomCode.toUpperCase());
      setShowPlayerInterface(true);
    }
  }, [urlRoomCode]);

  const handleJoinGame = () => {
    if (!roomCode.trim()) {
      toast({
        title: 'Error',
        description: 'Please enter a room code',
        variant: 'destructive'
      });
      return;
    }
    setShowPlayerInterface(true);
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  if (showPlayerInterface) {
    return (
      <PlayerInterface
        roomCode={roomCode}
        onExit={() => setShowPlayerInterface(false)} data-id="utuu6jx3w" data-path="src/components/gameify/GameJoinPage.tsx" />);


  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4" data-id="ppz9cer2p" data-path="src/components/gameify/GameJoinPage.tsx">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md" data-id="8uz5x738k" data-path="src/components/gameify/GameJoinPage.tsx">

        <Card data-id="fwn9uj6av" data-path="src/components/gameify/GameJoinPage.tsx">
          <CardHeader data-id="f99h3m7p9" data-path="src/components/gameify/GameJoinPage.tsx">
            <CardTitle className="text-center text-3xl bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent" data-id="v71hqcv77" data-path="src/components/gameify/GameJoinPage.tsx">
              <Gamepad2 className="h-8 w-8 mx-auto mb-2" data-id="2v8a3ks9y" data-path="src/components/gameify/GameJoinPage.tsx" />
              Join Game
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6" data-id="0205f4agu" data-path="src/components/gameify/GameJoinPage.tsx">
            <div className="text-center" data-id="6exxmc0p8" data-path="src/components/gameify/GameJoinPage.tsx">
              <p className="text-muted-foreground" data-id="5jmd77p7f" data-path="src/components/gameify/GameJoinPage.tsx">
                Enter the room code to join a live quiz game
              </p>
            </div>

            <div data-id="xah6fer12" data-path="src/components/gameify/GameJoinPage.tsx">
              <Label htmlFor="room-code" data-id="frqwu83il" data-path="src/components/gameify/GameJoinPage.tsx">Room Code</Label>
              <Input
                id="room-code"
                placeholder="Enter 6-digit room code"
                value={roomCode}
                onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                maxLength={6}
                className="text-center text-2xl font-mono font-bold"
                onKeyPress={(e) => e.key === 'Enter' && handleJoinGame()} data-id="m74chy0vq" data-path="src/components/gameify/GameJoinPage.tsx" />

            </div>

            <div className="flex gap-2" data-id="pcca9jsdi" data-path="src/components/gameify/GameJoinPage.tsx">
              <Button variant="outline" onClick={handleGoHome} className="flex-1" data-id="do6g37ee3" data-path="src/components/gameify/GameJoinPage.tsx">
                <ArrowLeft className="h-4 w-4 mr-2" data-id="ofmoh2z9k" data-path="src/components/gameify/GameJoinPage.tsx" />
                Home
              </Button>
              <Button onClick={handleJoinGame} className="flex-1" data-id="urzx0bn8f" data-path="src/components/gameify/GameJoinPage.tsx">
                Join Game
              </Button>
            </div>

            <div className="text-center" data-id="msb0txel9" data-path="src/components/gameify/GameJoinPage.tsx">
              <p className="text-sm text-muted-foreground" data-id="ypqk365eh" data-path="src/components/gameify/GameJoinPage.tsx">
                Scan the QR code from your teacher's screen or enter the room code above
              </p>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>);

};

export default GameJoinPage;